// extracted by mini-css-extract-plugin
module.exports = {"FooterPartner":"Partner_FooterPartner__W79Cg","FooterPartnerList":"Partner_FooterPartnerList__wfqN3"};